import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Date: any;
  JSON: any;
  AWSDateTime: any;
  AWSDate: any;
  AWSURL: any;
  AWSJSON: any;
  JSONObject: any;
};

export enum CalendarFormulaOperation {
  ADD = 'Add',
  SUBTRACT = 'Subtract'
}

export enum CalendarFormulaUnit {
  DAY = 'Day',
  FIRSTOFMONTH = 'FirstOfMonth',
  WEEKDAY = 'Weekday'
}

export enum AcademicCalendarStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type AcademicCalendarFilterInput = {
  status?: InputMaybe<Scalars['String']>;
};

export enum AccessLevelEnum {
  READ = 'read',
  READWRITE = 'readWrite'
}

export enum LeadDataSourceEnum {
  ADMISSIONS = 'admissions',
  ATS = 'ats',
  LEADSSERVICE = 'leadsService',
  PORTAL = 'portal'
}

export enum LeadTemplateTypeEnum {
  LEARNINGPARTNER = 'learningPartner',
  LEARNINGPARTNERWADMISSIONS = 'learningPartnerwAdmissions',
  UNIVERSITYBASE = 'universityBase'
}

export enum TransferFrequencyEnum {
  DAILY = 'daily',
  MONTHLY = 'monthly',
  WEEKLY = 'weekly'
}

export enum EmployerIdentifierDisplayTypeEnum {
  EMPLOYERNAME = 'employerName',
  EMPLOYERUUID = 'employerUuid',
  NONE = 'none'
}

export enum LearnerIdentifierDisplayTypeEnum {
  GUILDEXTERNALID = 'guildExternalId',
  GUILDUUID = 'guildUuid'
}

export enum PeriodTypeEnum {
  ACADEMICPERIOD = 'academicPeriod',
  TERM = 'term'
}

export enum PortalModuleAccessEnum {
  ADMIN = 'admin',
  ADMISSIONS = 'admissions',
  COURSES = 'courses',
  ELIGIBILITY = 'eligibility',
  FILES = 'files',
  FINANCIALS = 'financials',
  HOME = 'home',
  SPONSORSHIP = 'sponsorship',
  STUDENTS = 'students'
}

export enum CadenceEnum {
  DAILY = 'daily',
  TERM_START = 'term_start'
}

export enum EligibilityDeliverySourceEnum {
  ACADEMIC_ELIGIBILITY_DELIVERY = 'academic_eligibility_delivery',
  MODEL_M_SERVICES = 'model_m_services'
}

export enum EligibilityPopulationSourceEnum {
  ADMISSIONS_AND_ENROLLMENTS = 'admissions_and_enrollments',
  MODEL_M_SERVICES = 'model_m_services'
}

export enum EligibilityTypeCheckEnum {
  ACADEMIC = 'academic',
  CORPORATE = 'corporate',
  PROGRAM = 'program'
}

export enum LockDateCutOffEnum {
  TODAY = 'today',
  YESTERDAY = 'yesterday'
}

export enum EvGrainEnum {
  COURSE = 'COURSE',
  PROGRAM = 'PROGRAM'
}

export enum ReadFromAesEnum {
  DISABLED = 'DISABLED',
  PROD_ENABLED = 'PROD_ENABLED',
  UAT_ENABLED = 'UAT_ENABLED'
}

export enum PrimaryPaymentModalityEnum {
  DIRECTPAY = 'DirectPay',
  TUITIONASSISTANCE = 'TuitionAssistance',
  TUITIONREIMBURSEMENT = 'TuitionReimbursement'
}

export enum SupportsPaymentModalitiesEnum {
  DIRECTPAY = 'DirectPay',
  TUITIONASSISTANCE = 'TuitionAssistance',
  TUITIONREIMBURSEMENT = 'TuitionReimbursement'
}

export enum TuitionAssistancePartnerTypeEnum {
  EMPLOYERSPONSORED = 'EmployerSponsored',
  GUILDCERTIFIED = 'GuildCertified'
}

export type ApsFilterInput = {
  academicModel?: InputMaybe<Scalars['String']>;
  configName?: InputMaybe<Scalars['String']>;
  excludeNullConfigs?: InputMaybe<Scalars['Boolean']>;
  excludeTests?: InputMaybe<Scalars['Boolean']>;
  feature?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ApsOrderByInput = {
  direction: Scalars['String'];
  field: Scalars['String'];
};

export type ApsPaginationInput = {
  count: Scalars['Int'];
  page: Scalars['Int'];
};

export enum ErrorType {
  METADATAERROR = 'MetadataError',
  NOTFOUNDERROR = 'NotFoundError',
  OPTIMISTICLOCKERROR = 'OptimisticLockError',
  VALIDATIONERROR = 'ValidationError'
}

export enum TaxGrossupStatus {
  AVAILABLE = 'AVAILABLE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum NonStandardProductName {
  CANDIDLY = 'CANDIDLY',
  PROFESSIONAL_EXPENSES = 'PROFESSIONAL_EXPENSES'
}

export enum ProductStatusTag {
  ELIGIBLE = 'ELIGIBLE',
  ELIGIBLE_SOON = 'ELIGIBLE_SOON',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE'
}

export enum StandardProductName {
  DIRECT_PAYMENT = 'DIRECT_PAYMENT',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT'
}

export enum EligibilitySummaryCategoryStatus {
  FAIL = 'FAIL',
  PASS = 'PASS',
  UNKNOWN = 'UNKNOWN'
}

export enum CoveredFeeExpenseEnum {
  ENROLLMENT_FEE = 'ENROLLMENT_FEE',
  PROFESSIONAL_EXPENSE = 'PROFESSIONAL_EXPENSE',
  UNKNOWN = 'UNKNOWN'
}

export enum CoverageSummaryStatus {
  AVAILABLE = 'AVAILABLE',
  LOST = 'LOST',
  UPCOMING = 'UPCOMING'
}

export type BillingPeriodsFilters = {
  academicPartnerId: Scalars['String'];
  codes?: InputMaybe<Array<Scalars['String']>>;
};

export type BillingPeriodsOrderBySortInput = {
  name: BillingPeriodSortField;
  sort?: InputMaybe<AcsSortOrder>;
};

export enum BillingPeriodSortField {
  CODE = 'code',
  ID = 'id',
  NAME = 'name'
}

export enum AcsSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type PaginationInput = {
  count: Scalars['Int'];
  page: Scalars['Int'];
};

export type UserOverridesInput = {
  employerUuid?: InputMaybe<Scalars['ID']>;
  userUuid?: InputMaybe<Scalars['ID']>;
};

export enum ProgramKind {
  ADVANCED_CERTIFICATE = 'ADVANCED_CERTIFICATE',
  ASSOCIATE_OF_ARTS_DEGREE = 'ASSOCIATE_OF_ARTS_DEGREE',
  ASSOCIATE_OF_SCIENCE_DEGREE = 'ASSOCIATE_OF_SCIENCE_DEGREE',
  BACHELOR_OF_APPLIED_SCIENCE = 'BACHELOR_OF_APPLIED_SCIENCE',
  BACHELOR_OF_ARTS_DEGREE = 'BACHELOR_OF_ARTS_DEGREE',
  BACHELOR_OF_BUSINESS_ADMINISTRATION = 'BACHELOR_OF_BUSINESS_ADMINISTRATION',
  BACHELOR_OF_GENERAL_STUDIES = 'BACHELOR_OF_GENERAL_STUDIES',
  BACHELOR_OF_PROFESSIONAL_SERVICE_DEGREE = 'BACHELOR_OF_PROFESSIONAL_SERVICE_DEGREE',
  BACHELOR_OF_SCIENCE_DEGREE = 'BACHELOR_OF_SCIENCE_DEGREE',
  CERTIFICATE = 'CERTIFICATE',
  COLLEGE_PREP = 'COLLEGE_PREP',
  DOCTOR_OF_NURSING_PRACTICE = 'DOCTOR_OF_NURSING_PRACTICE',
  DOCTOR_OF_PHYSICAL_THERAPY = 'DOCTOR_OF_PHYSICAL_THERAPY',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  INTERMEDIATE_CERTIFICATE = 'INTERMEDIATE_CERTIFICATE',
  INTRODUCTORY_CERTIFICATE = 'INTRODUCTORY_CERTIFICATE',
  LANGUAGE = 'LANGUAGE',
  MASTER_OF_ARTS_DEGREE = 'MASTER_OF_ARTS_DEGREE',
  MASTER_OF_BUSINESS_ADMINISTRATION = 'MASTER_OF_BUSINESS_ADMINISTRATION',
  MASTER_OF_HEALTHCARE_ADMINISTRATION = 'MASTER_OF_HEALTHCARE_ADMINISTRATION',
  MASTER_OF_PUBLIC_ADMINISTRATION = 'MASTER_OF_PUBLIC_ADMINISTRATION',
  MASTER_OF_SCIENCE_DEGREE = 'MASTER_OF_SCIENCE_DEGREE',
  PROFESSIONAL_DEVELOPMENT = 'PROFESSIONAL_DEVELOPMENT'
}

export enum ShortProgramKind {
  ASSOCIATES = 'ASSOCIATES',
  BACHELORS = 'BACHELORS',
  CERTIFICATE = 'CERTIFICATE',
  COLLEGE_PREP = 'COLLEGE_PREP',
  DOCTORAL = 'DOCTORAL',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  LANGUAGE = 'LANGUAGE',
  MASTERS = 'MASTERS',
  PROFESSIONAL_DEVELOPMENT = 'PROFESSIONAL_DEVELOPMENT'
}

export type CourseEnrollmentsByBillingPeriodInput = {
  options: CourseEnrollmentsByBillingPeriodOptions;
  orderBy?: InputMaybe<Array<OrderByInputCourseEnrollment>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CourseEnrollmentsByBillingPeriodOptions = {
  billingPeriodId: Scalars['String'];
  enrollmentPeriodId?: InputMaybe<Scalars['String']>;
};

export type OrderByInputCourseEnrollment = {
  name: SortFieldCourseEnrollment;
  sort?: InputMaybe<SortOrder>;
};

export enum SortFieldCourseEnrollment {
  CREDITS = 'credits',
  EXTERNALPROGRAMCODE = 'externalProgramCode',
  EXTERNALSTUDENTIDENTIFIER = 'externalStudentIdentifier',
  RECORDEDAT = 'recordedAt'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum EnrollmentVerificationGrain {
  COURSE = 'COURSE',
  PROGRAM = 'PROGRAM'
}

export enum EnrollmentVerificationReason {
  ALL_COURSES_DROPPED_BEFORE_COMMITMENT_DATE = 'ALL_COURSES_DROPPED_BEFORE_COMMITMENT_DATE',
  ENROLLED = 'ENROLLED',
  NO_COURSES_FOR_PERIOD = 'NO_COURSES_FOR_PERIOD',
  NO_EV_FOR_PERIOD = 'NO_EV_FOR_PERIOD',
  NO_PROGRAMS_FOR_PERIOD = 'NO_PROGRAMS_FOR_PERIOD',
  SOME_COURSES_DROPPED_AFTER_COMMITMENT_DATE = 'SOME_COURSES_DROPPED_AFTER_COMMITMENT_DATE',
  SOME_PROGRAMS_ENROLLED = 'SOME_PROGRAMS_ENROLLED'
}

export enum EnrollmentVerificationState {
  NO_EV = 'NO_EV',
  PENDING = 'PENDING',
  REVERSED = 'REVERSED',
  VERIFIED = 'VERIFIED'
}

export enum AchievementTypeEnum {
  ASSOCIATEDEGREE = 'AssociateDegree',
  BACHELORSDEGREE = 'BachelorsDegree',
  CERTIFICATEORBOOTCAMP = 'CertificateOrBootcamp',
  COLLEGESTART = 'CollegeStart',
  DOCTORATEDEGREE = 'DoctorateDegree',
  HIGHSCHOOL = 'HighSchool',
  LANGUAGE = 'Language',
  MASTERSDEGREE = 'MastersDegree',
  UNKNOWN = 'Unknown'
}

export enum EnrollmentStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  INACTIVE = 'INACTIVE',
  PENDING_AP_APPROVAL = 'PENDING_AP_APPROVAL'
}

export type CourseEnrollmentsByGuildUuidInput = {
  options: CourseEnrollmentsByGuildUuidOptions;
  orderBy?: InputMaybe<Array<OrderByInputCourseEnrollment>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CourseEnrollmentsByGuildUuidOptions = {
  academicPartnerId?: InputMaybe<Scalars['String']>;
  effectiveStart?: InputMaybe<Scalars['String']>;
  guildUuid: Scalars['String'];
};

export enum CycMemberProgressFeedback {
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE'
}

export enum CycMemberProgressStatus {
  COMPLETED = 'COMPLETED'
}

export enum EligibilitySummaryStatus {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
  LOST = 'LOST',
  NULL_PLAN = 'NULL_PLAN',
  UPCOMING = 'UPCOMING'
}

export type EnrollmentPeriodsFilters = {
  academicPartnerId: Scalars['String'];
  codes?: InputMaybe<Array<Scalars['String']>>;
};

export type EnrollmentPeriodsOrderBySortInput = {
  name: EnrollmentPeriodSortField;
  sort?: InputMaybe<AcsSortOrder>;
};

export enum EnrollmentPeriodSortField {
  CODE = 'code',
  ID = 'id',
  NAME = 'name'
}

export type FieldsOfStudyInput = {
  filter: FieldsOfStudyFilter;
  groupId?: InputMaybe<Scalars['ID']>;
};

export enum FieldsOfStudyFilter {
  ACTIVE = 'Active',
  ALL = 'All',
  INACTIVE = 'Inactive'
}

export type FinancialIngestValidationResultsRequest = {
  filters?: InputMaybe<FinancialValidationResultsFilters>;
  ingestGroupId: Scalars['ID'];
};

export type FinancialValidationResultsFilters = {
  resultOutcomes?: InputMaybe<Array<InputMaybe<FinancialValidationResultOutcome>>>;
};

export enum FinancialValidationResultOutcome {
  FAIL = 'FAIL'
}

export enum FinancialValidationCategory {
  ENROLLMENT = 'ENROLLMENT',
  FORMAT = 'FORMAT',
  GENERAL = 'GENERAL',
  INVALID = 'INVALID',
  MONETARY = 'MONETARY',
  STUDENT = 'STUDENT',
  TERM = 'TERM'
}

export enum FinancialValidationCode {
  FIN_DUPLICATE001 = 'FIN_DUPLICATE001',
  FIN_FORMAT001 = 'FIN_FORMAT001',
  FIN_FORMAT002 = 'FIN_FORMAT002',
  FIN_FORMAT003 = 'FIN_FORMAT003',
  FIN_FORMAT004 = 'FIN_FORMAT004',
  FIN_GEN001 = 'FIN_GEN001',
  FIN_GEN002 = 'FIN_GEN002',
  FIN_INVALIDCHAR001 = 'FIN_INVALIDCHAR001',
  FIN_INVALIDCHAR003 = 'FIN_INVALIDCHAR003',
  FIN_MISSING002 = 'FIN_MISSING002',
  FIN_TERM001 = 'FIN_TERM001',
  FIN_TERM002 = 'FIN_TERM002',
  FIN_TERM006 = 'FIN_TERM006',
  FIN_TUITION001 = 'FIN_TUITION001',
  FIN_TUITION002 = 'FIN_TUITION002',
  FIN_TXENROLL001 = 'FIN_TXENROLL001',
  FIN_TXENROLL002 = 'FIN_TXENROLL002',
  FIN_UNKNOWNENTITY007 = 'FIN_UNKNOWNENTITY007',
  FIN_UNKNOWNENTITY010 = 'FIN_UNKNOWNENTITY010'
}

export enum ErrorLevel {
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  WARNING = 'WARNING'
}

export type FinancialReleaseValidationResultsRequest = {
  billingPeriodCohortId: Scalars['ID'];
  filters?: InputMaybe<FinancialValidationResultsFilters>;
};

export type Funding_BulkGetSpendByProductInput = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
  keys: Array<Funding_BulkGetSpendByProductKey>;
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_BulkGetSpendByProductKey = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  memberId: Scalars['ID'];
};

export enum Funding_Product {
  EXTERNAL = 'EXTERNAL',
  PROFESSIONAL_EXPENSES = 'PROFESSIONAL_EXPENSES',
  SPONSORSHIP = 'SPONSORSHIP',
  STUDENT_LOAN_BENEFIT = 'STUDENT_LOAN_BENEFIT',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT'
}

export type Funding_BulkGetStudentSpendByAchievementType = {
  audience?: InputMaybe<Scalars['String']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  keys: Array<Funding_BulkGetStudentSpendAchievementTypeRequestKey>;
  origin?: InputMaybe<Scalars['String']>;
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_BulkGetStudentSpendAchievementTypeRequestKey = {
  achievementType: Scalars['String'];
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
  guildUuid: Scalars['ID'];
};

export type Funding_BulkGetStudentSpendByProgramId = {
  audience?: InputMaybe<Scalars['String']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  keys: Array<Funding_BulkGetStudentSpendProgramIdRequestKey>;
  origin?: InputMaybe<Scalars['String']>;
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_BulkGetStudentSpendProgramIdRequestKey = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  guildUuid: Scalars['ID'];
  programUuid: Scalars['ID'];
};

export type Funding_GetAdjustmentFileUploadUrlInput = {
  fileName: Scalars['String'];
};

export type Funding_GetBenefitPeriodsByEmployerIdInput = {
  asOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
};

export enum Funding_Sequence {
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
  NEXT = 'NEXT',
  OLDER = 'OLDER',
  PREVIOUS = 'PREVIOUS'
}

export type Funding_GetCustomBenefitConfiguration = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  asOf: Scalars['AWSDate'];
  category: Funding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID'];
  memberId: Scalars['ID'];
};

export enum Funding_CustomBenefitConfigurationCategory {
  FALLBACK = 'fallback',
  MODIFY = 'modify',
  OVERRIDE = 'override'
}

export type Funding_GetLearnerSpendReportUrlInput = {
  fileName: Scalars['String'];
};

export type Funding_GetSpendByProductInput = {
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
  memberId: Scalars['ID'];
  product: Funding_Product;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_GetStudentSpend = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  achievementType?: InputMaybe<Scalars['String']>;
  audience?: InputMaybe<Scalars['String']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
  guildUuid: Scalars['ID'];
  origin?: InputMaybe<Scalars['String']>;
  partnerStudentId?: InputMaybe<Scalars['String']>;
  product: Funding_Product;
  programUuid?: InputMaybe<Scalars['ID']>;
  spendAsOf: Scalars['AWSDate'];
};

export type Funding_GetTaxPeriodsInput = {
  asOf?: InputMaybe<Scalars['AWSDate']>;
  employerId: Scalars['ID'];
};

export type Funding_ListAdjustments = {
  benefitLockedOn?: InputMaybe<Funding_DateRange>;
  committedAt?: InputMaybe<Funding_DateRange>;
  createdAt?: InputMaybe<Funding_DateTimeRange>;
  employerId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['String']>;
  expenseTypeId?: InputMaybe<Scalars['ID']>;
  guildUuid?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  payor?: InputMaybe<Funding_Payor>;
  product?: InputMaybe<Funding_Product>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type Funding_DateRange = {
  endDate?: InputMaybe<Scalars['AWSDate']>;
  startDate?: InputMaybe<Scalars['AWSDate']>;
};

export type Funding_DateTimeRange = {
  endDate?: InputMaybe<Scalars['AWSDateTime']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']>;
};

export enum Funding_Payor {
  EMPLOYER = 'employer',
  GUILD = 'guild'
}

export type Funding_ListJobsInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nameLike?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Funding_JobStatus>>>;
  types?: InputMaybe<Array<InputMaybe<Funding_JobType>>>;
};

export enum Funding_JobStatus {
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  PENDING = 'PENDING'
}

export enum Funding_JobType {
  CREATE_ADJUSTMENTS_FROM_FILE = 'CREATE_ADJUSTMENTS_FROM_FILE',
  CREATE_ADJUSTMENTS_FROM_FILE_DRY_RUN = 'CREATE_ADJUSTMENTS_FROM_FILE_DRY_RUN'
}

export enum Funding_ListJobsError {
  INVALID_INPUT = 'INVALID_INPUT',
  UNKNOWN = 'UNKNOWN'
}

export type Funding_ListLearnerSpendReportsInput = {
  employerId: Scalars['ID'];
  year: Scalars['String'];
};

export type Funding_ResolveJobInput = {
  id: Scalars['ID'];
};

export enum Funding_ResolveJobError {
  UNKNOWN = 'UNKNOWN'
}

export enum PaymentModality {
  DEFERRED_TUITION = 'DEFERRED_TUITION',
  DIRECT_PAYMENT_PROGRAM = 'DIRECT_PAYMENT_PROGRAM',
  PROFESSIONAL_EXPENSES = 'PROFESSIONAL_EXPENSES',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT'
}

export enum EligibilityType {
  ACADEMICPERFORMANCE = 'AcademicPerformance',
  CORPORATE = 'Corporate',
  ENROLLMENT = 'Enrollment'
}

export enum RuleLevel {
  COVERAGEPACKAGE = 'CoveragePackage',
  EMPLOYER = 'Employer'
}

export enum EmployerPolicyStatus {
  APPROVED = 'APPROVED',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  LIVE = 'LIVE'
}

export enum EmployerPolicyType {
  DEPENDENT = 'DEPENDENT',
  EMPLOYEE = 'EMPLOYEE',
  UNION = 'UNION'
}

export enum BenefitPreviewJobStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum EnrollmentIngestProcessingStatus {
  CLEAN = 'CLEAN',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  INFECTED = 'INFECTED',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED',
  SCANNING = 'SCANNING',
  SKIP = 'SKIP',
  UNKNOWN = 'UNKNOWN'
}

export enum SftpRoleName {
  EMPLOYERSTANDARDACCESS = 'EmployerStandardAccess',
  REPORTREADER = 'ReportReader',
  TESTFULLACCESS = 'TestFullAccess'
}

export type GuildProgramListInput = {
  academicPartnerId?: InputMaybe<Scalars['String']>;
  achievementTypeId?: InputMaybe<Scalars['String']>;
  includeTests?: InputMaybe<Scalars['Boolean']>;
  onlyOnCatalog?: InputMaybe<Scalars['Boolean']>;
  searchString?: InputMaybe<Scalars['String']>;
};

export type PsOrderBySortInput = {
  name: Scalars['String'];
  sort: PsOrderDirection;
};

export enum PsOrderDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export type PsPaginationInput = {
  count: Scalars['Int'];
  page: Scalars['Int'];
};

export enum PaymentModalityType {
  DIRECTPAY = 'DirectPay',
  TUITIONASSISTANCE = 'TuitionAssistance',
  TUITIONREIMBURSEMENT = 'TuitionReimbursement'
}

export type InstitutionFilterInput = {
  allowsDeferredTuition?: InputMaybe<Scalars['Boolean']>;
  effectiveAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  includeTests?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  primaryPaymentModalityType?: InputMaybe<PaymentModalityType>;
  requiresOptIn?: InputMaybe<Scalars['Boolean']>;
  supportsExclusiveEmployerPartnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportsPaymentModality?: InputMaybe<Array<InputMaybe<PaymentModalityType>>>;
};

export type InstitutionPaginationInput = {
  count?: InputMaybe<Scalars['Int']>;
  direction: InstitutionOrderByDirection;
  field: InstitutionOrderByField;
  lastFieldInResults?: InputMaybe<Scalars['String']>;
};

export enum InstitutionOrderByDirection {
  ASCEND = 'Ascend',
  DESCEND = 'Descend'
}

export enum InstitutionOrderByField {
  ID = 'Id',
  SHORTNAME = 'ShortName'
}

export enum BillingPeriodCohortBillingGrain {
  BILLING_PERIOD = 'BILLING_PERIOD',
  ENROLLMENT_PERIOD = 'ENROLLMENT_PERIOD'
}

export enum BillingPeriodCohortBillingType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION'
}

export enum BillingPeriodCohortState {
  FAILED_QA = 'FAILED_QA',
  PASSED_QA = 'PASSED_QA',
  RELEASED = 'RELEASED',
  RELEASED_WITH_OVERRIDE = 'RELEASED_WITH_OVERRIDE',
  REVIEW_REQUESTED = 'REVIEW_REQUESTED',
  UNEVALUATED = 'UNEVALUATED'
}

export enum LearningMarketplaceAvailability {
  INELIGIBLE = 'INELIGIBLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE'
}

export type ListEnrollmentDataIngestErrorsInput = {
  options: ListEnrollmentDataIngestErrorsOptions;
  pagination?: InputMaybe<PaginationInput>;
};

export type ListEnrollmentDataIngestErrorsOptions = {
  academicPartnerId?: InputMaybe<Scalars['String']>;
  correlationId?: InputMaybe<Scalars['String']>;
  dataSource: Scalars['String'];
};

export enum EnrollmentDataIngestFailureCode {
  ADMISSION002 = 'ADMISSION002',
  DUPLICATE001 = 'DUPLICATE001',
  ENROLLMENT001 = 'ENROLLMENT001',
  ENROLLMENT002 = 'ENROLLMENT002',
  ENROLLMENT003 = 'ENROLLMENT003',
  ENROLLMENT004 = 'ENROLLMENT004',
  ENROLLMENT005 = 'ENROLLMENT005',
  ENROLLMENT006 = 'ENROLLMENT006',
  ENROLLMENT007 = 'ENROLLMENT007',
  EV001 = 'EV001',
  EXTERNAL001 = 'EXTERNAL001',
  FORMAT001 = 'FORMAT001',
  FORMAT002 = 'FORMAT002',
  FORMAT003 = 'FORMAT003',
  FORMAT004 = 'FORMAT004',
  FORMAT005 = 'FORMAT005',
  FORMAT006 = 'FORMAT006',
  FORMAT007 = 'FORMAT007',
  GEN001 = 'GEN001',
  GEN004 = 'GEN004',
  INVALIDCHAR001 = 'INVALIDCHAR001',
  MISSING002 = 'MISSING002',
  MISSING003 = 'MISSING003',
  MISSING004 = 'MISSING004',
  MISSING005 = 'MISSING005',
  MULTIPLE002 = 'MULTIPLE002',
  TERM001 = 'TERM001',
  TERM002 = 'TERM002',
  TERM003 = 'TERM003',
  TERM004 = 'TERM004',
  TERM005 = 'TERM005',
  TERM006 = 'TERM006',
  UNKNOWNENTITY001 = 'UNKNOWNENTITY001',
  UNKNOWNENTITY003 = 'UNKNOWNENTITY003',
  UNKNOWNENTITY004 = 'UNKNOWNENTITY004',
  UNKNOWNENTITY006 = 'UNKNOWNENTITY006',
  UNKNOWNENTITY008 = 'UNKNOWNENTITY008',
  UNKNOWNENTITY014 = 'UNKNOWNENTITY014',
  UNKNOWNENTITY015 = 'UNKNOWNENTITY015',
  UNKNOWNENTITY016 = 'UNKNOWNENTITY016'
}

export enum EnrollmentDataIngestFailureLevel {
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  WARNING = 'WARNING'
}

export type ListEnrollmentDataIngestHistoryInput = {
  academicPartnerId: Scalars['String'];
  enrollmentPeriodCode?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<EnrollmentFileType>;
  pagination?: InputMaybe<PaginationInput>;
};

export enum EnrollmentFileType {
  COURSE_COMPLETION = 'COURSE_COMPLETION',
  COURSE_ENROLLMENT = 'COURSE_ENROLLMENT',
  STUDENT_PROGRESS = 'STUDENT_PROGRESS',
  STUDENT_STATUS = 'STUDENT_STATUS'
}

export type ProgramEnrollmentsCriteria = {
  academicPartnerId: Scalars['String'];
  billingPeriodIds?: InputMaybe<Array<Scalars['String']>>;
  effectiveStart?: InputMaybe<Scalars['String']>;
  enrollmentPeriodIds?: InputMaybe<Array<Scalars['String']>>;
  guildUuids?: InputMaybe<Array<Scalars['String']>>;
  hasCourseEnrollments?: InputMaybe<Scalars['Boolean']>;
  internalStudentIds?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<EnrollmentStatus>;
};

export type OrderByInputProgramEnrollment = {
  name: SortFieldProgramEnrollment;
  sort?: InputMaybe<SortOrder>;
};

export enum SortFieldProgramEnrollment {
  CUMULATIVEGPA = 'cumulativeGpa',
  ENDDATE = 'endDate',
  EXTERNALPROGRAMCODE = 'externalProgramCode',
  EXTERNALSTUDENTIDENTIFIER = 'externalStudentIdentifier',
  RECORDEDAT = 'recordedAt',
  STARTDATE = 'startDate'
}

export enum FolderLocation {
  DIRECTUPLOAD = 'DirectUpload',
  SFTP = 'SFTP'
}

export enum FolderType {
  PRODUCTION = 'production',
  TEST = 'test'
}

export type MemberUserSearchInput = {
  attribute: MemberUserSearchAttribute;
  paginationInput?: InputMaybe<PaginationInput>;
  searchTerm: Scalars['String'];
};

export enum MemberUserSearchAttribute {
  AUTHOID = 'AUTHOID',
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  PHONE = 'PHONE',
  UUID = 'UUID'
}

export type PartnerProgramListInput = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  asOf?: InputMaybe<Scalars['String']>;
  includeTests?: InputMaybe<Scalars['Boolean']>;
};

export enum PaymentNetworkAvailability {
  DEFERRED_TUITION = 'DEFERRED_TUITION',
  DIRECT_PAYMENT_PROGRAM = 'DIRECT_PAYMENT_PROGRAM',
  INELIGIBLE = 'INELIGIBLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT'
}

export enum BillingUnit {
  PERCREDIT = 'PerCredit',
  PERTERM = 'PerTerm'
}

export enum PriceFilter {
  ACTIVE = 'Active',
  VALID = 'Valid'
}

export enum PeriodType {
  BILLING = 'BILLING',
  ENROLLMENT = 'ENROLLMENT'
}

export type ProgramEnrollmentsByBillingPeriodInput = {
  options: ProgramEnrollmentsByBillingPeriodOptions;
  orderBy?: InputMaybe<Array<OrderByInputProgramEnrollment>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ProgramEnrollmentsByBillingPeriodOptions = {
  billingPeriodId: Scalars['String'];
  enrollmentPeriodIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ProgramEnrollmentsByGuildUuidInput = {
  options: ProgramEnrollmentsByGuildUuidOptions;
  orderBy?: InputMaybe<Array<OrderByInputProgramEnrollment>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ProgramEnrollmentsByGuildUuidOptions = {
  academicPartnerId?: InputMaybe<Scalars['String']>;
  effectiveStart?: InputMaybe<Scalars['String']>;
  guildUuid: Scalars['String'];
};

export type ProgramEnrollmentsByGuildUuidsInput = {
  options: ProgramEnrollmentsByGuildUuidsOptions;
  orderBy?: InputMaybe<Array<OrderByInputProgramEnrollment>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ProgramEnrollmentsByGuildUuidsOptions = {
  academicPartnerId?: InputMaybe<Scalars['String']>;
  effectiveStart?: InputMaybe<Scalars['String']>;
  guildUuids: Array<Scalars['String']>;
};

export type StudentSpendKey = {
  employerId: Scalars['ID'];
  product: Scalars['String'];
  programId?: InputMaybe<Scalars['ID']>;
  spendAsOf: Scalars['AWSDateTime'];
  userId: Scalars['ID'];
};

export type StudentTransactionFilterInput = {
  academicPartnerId: Scalars['ID'];
  active?: InputMaybe<StudentTransactionFilterActiveEnum>;
  billingPeriodCohortId?: InputMaybe<Scalars['ID']>;
  internalStudentIds?: InputMaybe<Array<Scalars['ID']>>;
  termId?: InputMaybe<Scalars['ID']>;
};

export enum StudentTransactionFilterActiveEnum {
  ALL = 'ALL',
  FALSE = 'FALSE',
  TRUE = 'TRUE'
}

export enum StudentTransactionRecordType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION'
}

export enum StudentTransactionState {
  FAILED_QA = 'FAILED_QA',
  PASSED_QA = 'PASSED_QA',
  RELEASED = 'RELEASED',
  RELEASED_WITH_OVERRIDE = 'RELEASED_WITH_OVERRIDE',
  REVIEW_REQUESTED = 'REVIEW_REQUESTED',
  UNEVALUATED = 'UNEVALUATED'
}

export type TermsFilters = {
  academicPartnerId: Scalars['ID'];
  addDropDeadlineDate?: InputMaybe<Scalars['String']>;
  codeNameSearch?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  includeTests?: InputMaybe<Scalars['Boolean']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  isFuture?: InputMaybe<Scalars['Boolean']>;
  isPast?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['String']>;
  startMonth?: InputMaybe<Scalars['String']>;
};

export type TermsOrderBySortInput = {
  name: TermSortField;
  sort?: InputMaybe<TermSortOrder>;
};

export enum TermSortField {
  ADDDROPDEADLINE = 'addDropDeadline',
  CODE = 'code',
  ELIGIBILITYFILETRANSFERDATE = 'eligibilityFileTransferDate',
  ENDDATE = 'endDate',
  ENROLLMENTFILETRANSFERDATE = 'enrollmentFileTransferDate',
  FINANCIALFILETRANSFERDATE = 'financialFileTransferDate',
  GRADESFILETRANSFERDATE = 'gradesFileTransferDate',
  ID = 'id',
  NAME = 'name',
  RECONFILETRANSFERDATE = 'reconFileTransferDate',
  STARTDATE = 'startDate'
}

export enum TermSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type TransactionRegistry_HelloWorld = {
  id: Scalars['String'];
};

export type AddFieldsOfStudyToGroupInput = {
  fieldOfStudyIds: Array<Scalars['ID']>;
  groupId: Scalars['ID'];
};

export type AcademicPeriodApprovals = {
  hasExternalCalendarApproval?: InputMaybe<Scalars['Boolean']>;
  hasExternalExchangeApproval?: InputMaybe<Scalars['Boolean']>;
  hasInternalCalendarApproval?: InputMaybe<Scalars['Boolean']>;
  hasInternalExchangeApproval?: InputMaybe<Scalars['Boolean']>;
};

export type ArchiveMemberUserInput = {
  archivedUuid: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  updatedById?: InputMaybe<Scalars['ID']>;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type BatchPartnerProgramProcessingInput = {
  apProgramCode: Scalars['String'];
  requestId: Scalars['ID'];
};

export enum PartnerProgramProcessingOutcome {
  CREATED = 'CREATED',
  ERROR = 'ERROR',
  FOUND = 'FOUND'
}

export enum ErrorCategory {
  GENERAL = 'GENERAL'
}

export enum ErrorCode {
  DUPLICATE = 'DUPLICATE',
  INVALIDINPUT = 'INVALIDINPUT',
  NOTFOUND = 'NOTFOUND'
}

export type BulkInsertInput = {
  academicPartnerId: Scalars['ID'];
  batchCorrelationId?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  records: Array<BillingPeriodWrapper>;
};

export type BillingPeriodWrapper = {
  billingPeriod: BulkInsertBillingPeriodInput;
  correlationId?: InputMaybe<Scalars['ID']>;
};

export type BulkInsertBillingPeriodInput = {
  academicPeriodId: Scalars['ID'];
  assessedTuitionFinalDate?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  eligibilityLockDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  enrollmentPeriods: Array<BulkInsertEnrollmentPeriodInput>;
  epCreditMemoAppDate?: InputMaybe<Scalars['String']>;
  epCreditMemoDate?: InputMaybe<Scalars['String']>;
  epServiceFeeInvoiceDate?: InputMaybe<Scalars['String']>;
  epServiceFeePaymentDate?: InputMaybe<Scalars['String']>;
  epTuitionInvoiceDate?: InputMaybe<Scalars['String']>;
  epTuitionPaymentDate?: InputMaybe<Scalars['String']>;
  expectedServiceFeeReconCreditMemoDate?: InputMaybe<Scalars['String']>;
  financialFileDate?: InputMaybe<Scalars['String']>;
  gradesFileDate?: InputMaybe<Scalars['String']>;
  guildPaysTuitionDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  prelimEligibilityDate?: InputMaybe<Scalars['String']>;
  reconFileDate?: InputMaybe<Scalars['String']>;
  reconInvoiceDate?: InputMaybe<Scalars['String']>;
  reconPaymentDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type BulkInsertEnrollmentPeriodInput = {
  code: Scalars['String'];
  commitmentDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  expectedEnrollmentFileDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export enum Acs_ErrorCategory {
  ACADEMIC_PARTNER = 'ACADEMIC_PARTNER',
  DATE = 'DATE',
  ISSUE = 'ISSUE',
  RELATIONSHIP = 'RELATIONSHIP'
}

export enum Acs_ErrorCode {
  ACADEMIC_PARTNER_NOT_FOUND = 'ACADEMIC_PARTNER_NOT_FOUND',
  DUPLICATE_SESSION = 'DUPLICATE_SESSION',
  INVALID_DATE = 'INVALID_DATE',
  INVALID_INPUT = 'INVALID_INPUT',
  INVALID_PARENT = 'INVALID_PARENT',
  SESSION_START_END_DATE_RANGE = 'SESSION_START_END_DATE_RANGE',
  START_END_DATE_RANGE = 'START_END_DATE_RANGE',
  TERM_CODE = 'TERM_CODE',
  UNKNOWN = 'UNKNOWN'
}

export enum Acs_ErrorLevel {
  ERROR = 'ERROR',
  FATAL = 'FATAL'
}

export type AcademicCalendarInput = {
  academicPartnerId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  skipFormulas?: InputMaybe<Scalars['Boolean']>;
  status: AcademicCalendarStatus;
};

export type CreateAcademicPeriodInput = {
  academicPartnerId: Scalars['ID'];
  calendarId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nextAcademicPeriodId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AcademicPartnerAdmissionsFeatureCreateInput = {
  accessLevel: AccessLevelEnum;
  hasAdmissions: Scalars['Boolean'];
  hasITE: Scalars['Boolean'];
  hasTermRestrictedLeads: Scalars['Boolean'];
  leadDataSource: LeadDataSourceEnum;
  leadFileGeneration?: InputMaybe<Scalars['Boolean']>;
  leadTemplateType?: InputMaybe<LeadTemplateTypeEnum>;
  leadTransferOverSFTP: Scalars['Boolean'];
  transferFrequency: TransferFrequencyEnum;
};

export type AcademicPartnerCreateInput = {
  academicModel: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  logoFiles: AcademicPartnerLogoInput;
  name: Scalars['String'];
  portalConfigId?: InputMaybe<Scalars['String']>;
  shortName: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type AcademicPartnerLogoInput = {
  colorLogo?: InputMaybe<Scalars['String']>;
  logoAltText?: InputMaybe<Scalars['String']>;
  whiteLogo?: InputMaybe<Scalars['String']>;
};

export type CreateBillingPeriodInput = {
  academicPartnerId: Scalars['ID'];
  academicPeriodId: Scalars['ID'];
  assessedTuitionFinalDate?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  createdBy?: InputMaybe<Scalars['String']>;
  eligibilityLockDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  epCreditMemoAppDate?: InputMaybe<Scalars['String']>;
  epCreditMemoDate?: InputMaybe<Scalars['String']>;
  epServiceFeeInvoiceDate?: InputMaybe<Scalars['String']>;
  epServiceFeePaymentDate?: InputMaybe<Scalars['String']>;
  epTuitionInvoiceDate?: InputMaybe<Scalars['String']>;
  epTuitionPaymentDate?: InputMaybe<Scalars['String']>;
  expectedServiceFeeReconCreditMemoDate?: InputMaybe<Scalars['String']>;
  financialFileDate?: InputMaybe<Scalars['String']>;
  gradesFileDate?: InputMaybe<Scalars['String']>;
  guildPaysTuitionDate?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  prelimEligibilityDate?: InputMaybe<Scalars['String']>;
  reconFileDate?: InputMaybe<Scalars['String']>;
  reconInvoiceDate?: InputMaybe<Scalars['String']>;
  reconPaymentDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AcademicPartnerCommonFeatureCreateInput = {
  employerIdentifierDisplayType: EmployerIdentifierDisplayTypeEnum;
  hasHistoricalSessions?: InputMaybe<Scalars['Boolean']>;
  learnerIdentifierDisplayType?: InputMaybe<LearnerIdentifierDisplayTypeEnum>;
  periodType?: InputMaybe<PeriodTypeEnum>;
  portalModuleAccess: Array<PortalModuleAccessEnum>;
};

export type AcademicPartnerEligibilityFeatureCreateInput = {
  cadence: CadenceEnum;
  eligibilityDeliverySource?: InputMaybe<EligibilityDeliverySourceEnum>;
  eligibilityPopulationSource: EligibilityPopulationSourceEnum;
  eligibilityTypeCheck: Array<EligibilityTypeCheckEnum>;
  lockDateCutOff: LockDateCutOffEnum;
};

export type EmployerResourcesInput = {
  accessType?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  value: Scalars['String'];
  valueType: Scalars['String'];
};

export type EmployerPolicyCreateInput = {
  effective: Scalars['AWSDate'];
  employerId: Scalars['String'];
  goLive?: InputMaybe<Scalars['AWSDate']>;
  id?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['AWSJSON']>;
  requestedBy: Scalars['String'];
  type: Scalars['String'];
  versionDescription: Scalars['String'];
  versionName: Scalars['String'];
};

export enum EncryptionAlgorithm {
  EDDSA = 'EDDSA',
  RSA4096 = 'RSA4096'
}

export type CreateEnrollmentPeriodInput = {
  academicPartnerId: Scalars['String'];
  billingPeriodId: Scalars['ID'];
  code: Scalars['String'];
  commitmentDate?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  expectedEnrollmentFileDate?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type AcademicPartnerEnrollmentsFeatureCreateInput = {
  evGrain: EvGrainEnum;
  hasConcurrentProgramEnrollments?: InputMaybe<Scalars['Boolean']>;
  hasPendingProgramEnrollments?: InputMaybe<Scalars['Boolean']>;
  readFromAES?: InputMaybe<ReadFromAesEnum>;
  upsertEndDateGracePeriod?: InputMaybe<Scalars['Int']>;
};

export type FieldOfStudyGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type AcademicPartnerFileIngestFeatureCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  encrypted?: InputMaybe<Scalars['Boolean']>;
  fileTypes: Array<AcademicPartnerFileIngestFeatureFileTypesElementCreateInput>;
};

export type AcademicPartnerFileIngestFeatureFileTypesElementCreateInput = {
  customDateFormat?: InputMaybe<Scalars['String']>;
  defaultFilePathOverride?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  encrypted?: InputMaybe<Scalars['Boolean']>;
  fileNamePattern: Scalars['String'];
  fileType: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
};

export type GuildProgramCreateInput = {
  achievementTypeId: Scalars['String'];
  guildProgramName: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type InstitutionCreateInput = {
  academicModel?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  logoFiles?: InputMaybe<AcademicPartnerLogoInput>;
  name: Scalars['String'];
  portalConfigId?: InputMaybe<Scalars['String']>;
  shortName: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type InstitutionPaymentNetworkFeatureCreateInput = {
  allowsDeferredTuition?: InputMaybe<Scalars['Boolean']>;
  billsDirectly?: InputMaybe<Scalars['Boolean']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  exclusiveEmployerPartnerIds?: InputMaybe<Array<Scalars['String']>>;
  primaryPaymentModality: PaymentModalityType;
  requiresOptIn?: InputMaybe<Scalars['Boolean']>;
  sponsoringEmployerIds?: InputMaybe<Array<Scalars['String']>>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  submissionUrl?: InputMaybe<Scalars['String']>;
  supportsPaymentModalities: Array<PaymentModalityType>;
  tuitionAssistancePartnerType?: InputMaybe<TuitionAssistancePartnerType>;
};

export enum TuitionAssistancePartnerType {
  EMPLOYERSPONSORED = 'EmployerSponsored',
  GUILDCERTIFIED = 'GuildCertified'
}

export type AcademicPartnerPaymentNetworkFeatureCreateInput = {
  allowsDeferredTuition?: InputMaybe<Scalars['Boolean']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  exclusiveEmployerPartnerIds?: InputMaybe<Array<Scalars['String']>>;
  primaryPaymentModality: PrimaryPaymentModalityEnum;
  requiresOptIn?: InputMaybe<Scalars['Boolean']>;
  sponsoringEmployerIds?: InputMaybe<Array<Scalars['String']>>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  submissionUrl?: InputMaybe<Scalars['String']>;
  supportsPaymentModalities: Array<SupportsPaymentModalitiesEnum>;
  tuitionAssistancePartnerType?: InputMaybe<TuitionAssistancePartnerTypeEnum>;
};

export type SubmapLinkInput = {
  name: Scalars['String'];
  path: Scalars['String'];
};

export type CreateSkillingMemberUserInput = {
  employerId: Scalars['ID'];
  employerName: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  primaryEmail: Scalars['String'];
  primaryPhone?: InputMaybe<Scalars['String']>;
};

export type TermCreateInput = {
  academicPartnerId: Scalars['ID'];
  code: Scalars['String'];
  createdBy?: InputMaybe<Scalars['String']>;
  dates: TermDatesInput;
  isTest?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type TermDatesInput = {
  addDropDeadline?: InputMaybe<Scalars['String']>;
  eligibilityFileTransferDate?: InputMaybe<Scalars['String']>;
  eligibilityLockDate?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  enrollmentFileTransferDate?: InputMaybe<Scalars['String']>;
  financialFileTransferDate?: InputMaybe<Scalars['String']>;
  gradesFileTransferDate?: InputMaybe<Scalars['String']>;
  reconFileTransferDate?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
};

export type DeactivateTransactionsRequest = {
  transactionIds: Array<Scalars['ID']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type DeleteMemberUserAuth0Input = {
  auth0Id: Scalars['String'];
};

export type DeletePartnerProgramInput = {
  deletedBy: Scalars['String'];
  id: Scalars['ID'];
  version: Scalars['Int'];
};

export type EditFieldOfStudyGroupInput = {
  groupId: Scalars['ID'];
  name: Scalars['String'];
};

export type EvaluateBillingPeriodCohortRequest = {
  billingPeriodCohortId: Scalars['ID'];
};

export type FindOrCreateInternalUserByAuth0IdInput = {
  auth0Id: Scalars['String'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  guildOktaTestUser?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type FindOrCreateMemberUserByAuth0IdInput = {
  auth0Id: Scalars['String'];
  employeeId?: InputMaybe<Scalars['String']>;
  employerId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  primaryEmail?: InputMaybe<Scalars['String']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  publishSkillingAccountActivatedEvent?: InputMaybe<Scalars['Boolean']>;
  referrerEmail?: InputMaybe<Scalars['String']>;
};

export type Funding_BulkCreateCustomBenefitConfigurationInput = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  assignedBy: Scalars['ID'];
  category: Funding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  fundingLimits: Array<InputMaybe<Funding_CustomFundingLimitInput>>;
  grossUpEligibility?: InputMaybe<Scalars['Boolean']>;
  guildUuids: Array<Scalars['ID']>;
  metadata: Scalars['AWSJSON'];
  reason: Scalars['String'];
  startsOn: Scalars['AWSDate'];
  taxSection?: InputMaybe<Scalars['String']>;
};

export type Funding_CustomFundingLimitInput = {
  expenseTypes: Array<Scalars['String']>;
  fundingLimitCents?: InputMaybe<Scalars['Int']>;
  includedInTuition?: InputMaybe<Scalars['Boolean']>;
};

export type Funding_BulkUpdateTaxPeriodsInput = {
  employerId: Scalars['ID'];
  taxPeriods?: InputMaybe<Array<InputMaybe<Funding_UpdateTaxPeriods>>>;
};

export type Funding_UpdateTaxPeriods = {
  endsAfter: Scalars['AWSDate'];
  id: Scalars['ID'];
  startsOn: Scalars['AWSDate'];
};

export type Funding_CreateAdjustmentsFromFileInput = {
  asyncRequestId?: InputMaybe<Scalars['ID']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  employerId?: InputMaybe<Scalars['ID']>;
  expenseTypeId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  originProduct?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Funding_Product>;
  reason?: InputMaybe<Scalars['String']>;
  supportingDocuments?: InputMaybe<Scalars['String']>;
};

export type Funding_CreateBenefitPeriodInput = {
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  startsOn: Scalars['AWSDate'];
};

export type Funding_CreateCustomBenefitConfigurationInput = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  assignedBy: Scalars['ID'];
  category: Funding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  fundingLimits: Array<InputMaybe<Funding_CustomFundingLimitInput>>;
  grossUpEligibility?: InputMaybe<Scalars['Boolean']>;
  guildUuid: Scalars['ID'];
  metadata: Scalars['AWSJSON'];
  reason: Scalars['String'];
  startsOn: Scalars['AWSDate'];
  taxSection?: InputMaybe<Scalars['String']>;
};

export type Funding_CreateSpend = {
  academicInstitutionName?: InputMaybe<Scalars['String']>;
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  amountCents: Scalars['Int'];
  benefitLockedOn: Scalars['String'];
  capAsOf: Scalars['String'];
  committedAt: Scalars['String'];
  eligibleOnly?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  expenseTypeId: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  isCrossYear?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['String']>;
  memberAttestedTaxSection132?: InputMaybe<Scalars['Boolean']>;
  memberId: Scalars['ID'];
  metadata?: InputMaybe<Scalars['AWSJSON']>;
  origin: Scalars['String'];
  originApplicationId?: InputMaybe<Scalars['String']>;
  originProduct?: InputMaybe<Scalars['String']>;
  originRecordId: Scalars['String'];
  originRecordName: Scalars['String'];
  payor?: InputMaybe<Funding_Payor>;
  product: Funding_Product;
  productContext?: InputMaybe<ProductContext>;
};

export type ProductContext = {
  sponsorship?: InputMaybe<SponsorshipProductContext>;
  tuitionAssistance?: InputMaybe<TuitionAssistanceProductContext>;
  tuitionReimbursement?: InputMaybe<TuitionReimbursementProductContext>;
};

export type SponsorshipProductContext = {
  achievementType: Scalars['String'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
};

export type TuitionAssistanceProductContext = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  programId?: InputMaybe<Scalars['ID']>;
};

export type TuitionReimbursementProductContext = {
  achievementType: Scalars['String'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']>;
};

export type Funding_CreateTaxPeriodInput = {
  employerId: Scalars['ID'];
  endsAfter: Scalars['AWSDate'];
  startsOn: Scalars['AWSDate'];
};

export type Funding_GenerateLearnerSpendReport = {
  additionalColumns?: InputMaybe<Funding_AdditionalColumns>;
  bypassCrossYearReversals?: InputMaybe<Scalars['Boolean']>;
  employerId: Scalars['ID'];
  filter?: InputMaybe<Funding_ReportFilter>;
  filterByPlanFundingPeriods?: InputMaybe<Scalars['Boolean']>;
  includeGuildUuid?: InputMaybe<Scalars['Boolean']>;
  inNetworkTR?: InputMaybe<Scalars['Boolean']>;
  productFilters?: InputMaybe<Funding_ProductFilters>;
  taxEligibleOnCutoffDate?: InputMaybe<Scalars['AWSDate']>;
  type: Funding_LearnerSpendReportType;
};

export type Funding_AdditionalColumns = {
  employee?: InputMaybe<Array<Scalars['String']>>;
};

export type Funding_ReportFilter = {
  benefitLockedOn?: InputMaybe<Funding_DateRange>;
  committedAt?: InputMaybe<Funding_DateRange>;
  taxEligibleOn?: InputMaybe<Funding_DateRange>;
};

export type Funding_ProductFilters = {
  balanceTransfer?: InputMaybe<Funding_ReportFilter>;
  sponsorship?: InputMaybe<Funding_ReportFilter>;
  studentLoanReimbursement?: InputMaybe<Funding_ReportFilter>;
  tuitionAssistance?: InputMaybe<Funding_ReportFilter>;
  tuitionReimbursement?: InputMaybe<Funding_ReportFilter>;
};

export enum Funding_LearnerSpendReportType {
  EMPLOYEE = 'EMPLOYEE',
  FAMILY_MEMBER = 'FAMILY_MEMBER',
  NEGATIVE_CROSS_YEAR = 'NEGATIVE_CROSS_YEAR'
}

export type Funding_UpdateCustomBenefitConfiguration = {
  academicPartnerId?: InputMaybe<Scalars['ID']>;
  assignedBy: Scalars['ID'];
  category?: InputMaybe<Scalars['String']>;
  customBenefitConfigurationId: Scalars['ID'];
  employerId?: InputMaybe<Scalars['ID']>;
  endsAfter?: InputMaybe<Scalars['AWSDate']>;
  fundingLimits?: InputMaybe<Array<InputMaybe<Funding_CustomFundingLimitInput>>>;
  grossUpEligibility?: InputMaybe<Scalars['Boolean']>;
  guildUuid?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Scalars['AWSJSON']>;
  reason?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['AWSDate']>;
  taxSection?: InputMaybe<Scalars['String']>;
};

export type NewPartnerProgramVersionInput = {
  academicPartnerId: Scalars['ID'];
  code: Scalars['String'];
  createdBy: Scalars['String'];
  guildProgramId: Scalars['ID'];
  id: Scalars['ID'];
  versionEnd?: InputMaybe<Scalars['String']>;
  versionStart: Scalars['String'];
};

export type PublishRollcallCalendarInput = {
  academicPartnerId: Scalars['ID'];
  calendarId: Scalars['ID'];
  published: Scalars['Boolean'];
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type ReleaseBillingPeriodCohortRequest = {
  billingPeriodCohortId: Scalars['ID'];
  isReleaseWithOverride: Scalars['Boolean'];
  overrideExplanation?: InputMaybe<Array<Scalars['String']>>;
  skipEvaluation?: InputMaybe<Scalars['Boolean']>;
};

export type SaveEmployerConfigInput = {
  employerId: Scalars['ID'];
  pathwaysEnabled: Scalars['Boolean'];
};

export type AcademicPartnerPaymentNetworkFeatureUpdateInput = {
  allowsDeferredTuition?: InputMaybe<Scalars['Boolean']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  exclusiveEmployerPartnerIds?: InputMaybe<Array<Scalars['String']>>;
  primaryPaymentModality?: InputMaybe<PrimaryPaymentModalityEnum>;
  requiresOptIn?: InputMaybe<Scalars['Boolean']>;
  sponsoringEmployerIds?: InputMaybe<Array<Scalars['String']>>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  submissionUrl?: InputMaybe<Scalars['String']>;
  supportsPaymentModalities?: InputMaybe<Array<SupportsPaymentModalitiesEnum>>;
  tuitionAssistancePartnerType?: InputMaybe<TuitionAssistancePartnerTypeEnum>;
};

export type AcademicPartnerAdmissionsFeatureUpdateInput = {
  accessLevel?: InputMaybe<AccessLevelEnum>;
  hasAdmissions?: InputMaybe<Scalars['Boolean']>;
  hasITE?: InputMaybe<Scalars['Boolean']>;
  hasTermRestrictedLeads?: InputMaybe<Scalars['Boolean']>;
  leadDataSource?: InputMaybe<LeadDataSourceEnum>;
  leadFileGeneration?: InputMaybe<Scalars['Boolean']>;
  leadTemplateType?: InputMaybe<LeadTemplateTypeEnum>;
  leadTransferOverSFTP?: InputMaybe<Scalars['Boolean']>;
  transferFrequency?: InputMaybe<TransferFrequencyEnum>;
};

export type AcademicPartnerUpdateInput = {
  academicModel?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  logoFiles?: InputMaybe<AcademicPartnerLogoInput>;
  name?: InputMaybe<Scalars['String']>;
  portalConfigId?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedBy: Scalars['String'];
};

export type UpdateBillingPeriodCohortStateExcludingReleaseRequest = {
  billingPeriodCohortId: Scalars['ID'];
  state: BillingPeriodCohortState;
};

export type AcademicPartnerCommonFeatureUpdateInput = {
  employerIdentifierDisplayType?: InputMaybe<EmployerIdentifierDisplayTypeEnum>;
  hasHistoricalSessions?: InputMaybe<Scalars['Boolean']>;
  learnerIdentifierDisplayType?: InputMaybe<LearnerIdentifierDisplayTypeEnum>;
  periodType?: InputMaybe<PeriodTypeEnum>;
  portalModuleAccess?: InputMaybe<Array<PortalModuleAccessEnum>>;
};

export type AcademicPartnerEligibilityFeatureUpdateInput = {
  cadence?: InputMaybe<CadenceEnum>;
  eligibilityDeliverySource?: InputMaybe<EligibilityDeliverySourceEnum>;
  eligibilityPopulationSource?: InputMaybe<EligibilityPopulationSourceEnum>;
  eligibilityTypeCheck?: InputMaybe<Array<EligibilityTypeCheckEnum>>;
  lockDateCutOff?: InputMaybe<LockDateCutOffEnum>;
};

export type EmployerPolicyUpdateInput = {
  effective: Scalars['AWSDate'];
  employerId: Scalars['String'];
  goLive?: InputMaybe<Scalars['AWSDate']>;
  id?: InputMaybe<Scalars['String']>;
  policy: Scalars['AWSJSON'];
  requestedBy: Scalars['String'];
  type: Scalars['String'];
  versionDescription: Scalars['String'];
  versionName: Scalars['String'];
};

export type AcademicPartnerEnrollmentsFeatureUpdateInput = {
  evGrain?: InputMaybe<EvGrainEnum>;
  hasConcurrentProgramEnrollments?: InputMaybe<Scalars['Boolean']>;
  hasPendingProgramEnrollments?: InputMaybe<Scalars['Boolean']>;
  readFromAES?: InputMaybe<ReadFromAesEnum>;
  upsertEndDateGracePeriod?: InputMaybe<Scalars['Int']>;
};

export type AcademicPartnerFileIngestFeatureUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  encrypted?: InputMaybe<Scalars['Boolean']>;
  fileTypes?: InputMaybe<Array<AcademicPartnerFileIngestFeatureFileTypesElementUpdateInput>>;
};

export type AcademicPartnerFileIngestFeatureFileTypesElementUpdateInput = {
  customDateFormat?: InputMaybe<Scalars['String']>;
  defaultFilePathOverride?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  encrypted?: InputMaybe<Scalars['Boolean']>;
  fileNamePattern?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
};

export type GuildProgramUpdateInput = {
  achievementTypeId?: InputMaybe<Scalars['String']>;
  guildProgramId: Scalars['String'];
  guildProgramName?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type InstitutionUpdateInput = {
  academicModel?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  logoFiles?: InputMaybe<AcademicPartnerLogoInput>;
  name?: InputMaybe<Scalars['String']>;
  portalConfigId?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedBy: Scalars['String'];
};

export type UpdateMemberUserNameInput = {
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type UpdateProgramEnrollmentStatusInput = {
  academicPartnerId: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  externalProgramCode: Scalars['String'];
  guildUuid: Scalars['String'];
  recordedBy?: InputMaybe<Scalars['String']>;
  status: EnrollmentStatus;
};

export type TermUpdateInput = {
  dates?: InputMaybe<TermDatesInput>;
  name?: InputMaybe<Scalars['String']>;
  parentTermId?: InputMaybe<Scalars['ID']>;
};

export enum BulkImportMode {
  CORRECTION = 'Correction',
  REFRESH = 'Refresh'
}

export type UpsertContactStrategyInput = {
  contactType: Scalars['Int'];
  userId: Scalars['ID'];
  value: Scalars['String'];
};

export type UpsertEpPortalUserInput = {
  active: Scalars['Boolean'];
  email: Scalars['String'];
  employeeId: Scalars['String'];
  employerId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  roles: Array<InputMaybe<Scalars['String']>>;
};

export type UpsertExchangeDateFormulasInput = {
  exchangeDateTypeId: Scalars['ID'];
  offsetFormula: Scalars['String'];
};

export type UpsertMemberUserAuth0Input = {
  auth0Id: Scalars['String'];
  userId: Scalars['ID'];
};

export type UpsertRollcallBillingAndEnrollmentPeriodsInput = {
  assessedTuitionFinalDate: Scalars['String'];
  code: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  enrollmentPeriods: Array<UpsertEnrollmentPeriodsInput>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type UpsertEnrollmentPeriodsInput = {
  billingPeriodId?: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  commitmentDate: Scalars['String'];
  endDate: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  startDate: Scalars['String'];
};

export type RollcallCalendarAndAcademicPeriodsInput = {
  academicPartnerId: Scalars['String'];
  academicPeriods: Array<RollcallAcademicPeriodInput>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarName: Scalars['String'];
  calendarNotes: Scalars['String'];
  formulas: UpsertRollcallCalendarFormulasInput;
};

export type RollcallAcademicPeriodInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpsertRollcallCalendarFormulasInput = {
  commitmentDate?: InputMaybe<CalendarFormula>;
  eligibilityFileTransfer?: InputMaybe<CalendarFormula>;
  enrollmentFile?: InputMaybe<CalendarFormula>;
  epTuitionPayment?: InputMaybe<CalendarFormula>;
  financialFile?: InputMaybe<CalendarFormula>;
  gradeFile?: InputMaybe<CalendarFormula>;
  reconFile?: InputMaybe<CalendarFormula>;
  serviceFeeInvoice?: InputMaybe<CalendarFormula>;
  serviceFeePayment?: InputMaybe<CalendarFormula>;
  tuitionReconPayment?: InputMaybe<CalendarFormula>;
};

export type CalendarFormula = {
  amount: Scalars['Int'];
  operation: CalendarFormulaOperation;
  unit: CalendarFormulaUnit;
};

export type UpsertRollcallDataExchangeDatesInput = {
  billingPeriodId: Scalars['ID'];
  eligibilityFileTransferDate?: InputMaybe<Scalars['String']>;
  enrollmentPeriods: Array<UpsertRollcallDataExchangeEnrollmentDatesInput>;
  epTuitionPayment?: InputMaybe<Scalars['String']>;
  financialFile?: InputMaybe<Scalars['String']>;
  gradeFile?: InputMaybe<Scalars['String']>;
  reconFile?: InputMaybe<Scalars['String']>;
  serviceFeeInvoice?: InputMaybe<Scalars['String']>;
  serviceFeePayment?: InputMaybe<Scalars['String']>;
  tuitionReconPayment?: InputMaybe<Scalars['String']>;
};

export type UpsertRollcallDataExchangeEnrollmentDatesInput = {
  enrollmentFile?: InputMaybe<Scalars['String']>;
  enrollmentPeriodId: Scalars['ID'];
};

export type UpsertRollcallDataExchangeFormulasInput = {
  academicPartnerId: Scalars['ID'];
  academicPeriodIds?: InputMaybe<Array<Scalars['ID']>>;
  calendarId: Scalars['ID'];
  commitmentDate?: InputMaybe<CalendarFormula>;
  eligibilityFileTransfer?: InputMaybe<CalendarFormula>;
  enrollmentFile?: InputMaybe<CalendarFormula>;
  epTuitionPayment?: InputMaybe<CalendarFormula>;
  financialFile?: InputMaybe<CalendarFormula>;
  gradeFile?: InputMaybe<CalendarFormula>;
  reconFile?: InputMaybe<CalendarFormula>;
  serviceFeeInvoice?: InputMaybe<CalendarFormula>;
  serviceFeePayment?: InputMaybe<CalendarFormula>;
  skipFormulas: Scalars['Boolean'];
  tuitionReconPayment?: InputMaybe<CalendarFormula>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type TermUpsertInputWrapper = {
  correlationId?: InputMaybe<Scalars['ID']>;
  term: TermUpsertInput;
};

export type TermUpsertInput = {
  code: Scalars['String'];
  createdBy?: InputMaybe<Scalars['String']>;
  dates: TermDatesInput;
  name: Scalars['String'];
  sessions?: InputMaybe<Array<SessionCreateInput>>;
};

export type SessionCreateInput = {
  code: Scalars['String'];
  dates: TermDatesInput;
  name: Scalars['String'];
};

export enum Acs_BatchProcessingOutcome {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED'
}

export type WritePathwaysForEmployerInput = {
  employerId: Scalars['ID'];
  employerName: Scalars['String'];
  pathwayEnabled: Scalars['Boolean'];
  pathwayId: Scalars['ID'];
  roles?: InputMaybe<Array<InputMaybe<PathwayCustomRoleInput>>>;
};

export type PathwayCustomRoleInput = {
  baseEntryId: Scalars['ID'];
  customCommonTitles?: InputMaybe<Scalars['String']>;
  customEducation?: InputMaybe<Scalars['String']>;
  entryId?: InputMaybe<Scalars['ID']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type EligibilitySummaryQueryVariables = Exact<{
  uuid: Scalars['ID'];
  employeeId: Scalars['ID'];
  employerUuid: Scalars['ID'];
}>;


export type EligibilitySummaryQuery = { eligibilitySummary?: { categories: Array<{ status: EligibilitySummaryCategoryStatus, categoryTag: string, categoryTitle?: string | null } | null>, metadata?: { tenureDays?: number | null } | null } | null };

export type GetPathwayQueryVariables = Exact<{
  pathwayId: Scalars['ID'];
  employerId: Scalars['ID'];
}>;


export type GetPathwayQuery = { pathway?: { content: { heroImage?: string | null, title?: string | null } } | null };

export type PricesByProgramQueryVariables = Exact<{
  academicPartnerUuid: Scalars['ID'];
  programUuid: Scalars['ID'];
  filters?: InputMaybe<Array<PriceFilter> | PriceFilter>;
}>;


export type PricesByProgramQuery = { pricesByProgram: Array<{ billingUnit: BillingUnit, costPerUnit: number, priceType: { name: string } }> };


export const EligibilitySummaryDocument = gql`
    query eligibilitySummary($uuid: ID!, $employeeId: ID!, $employerUuid: ID!) {
  eligibilitySummary(uuid: $uuid, employeeId: $employeeId, employerUuid: $employerUuid) {
    categories {
      status
      categoryTag: category_tag
      categoryTitle: category_title
    }
    metadata {
      tenureDays: tenure_days
    }
  }
}
    `;

/**
 * __useEligibilitySummaryQuery__
 *
 * To run a query within a React component, call `useEligibilitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibilitySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibilitySummaryQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      employeeId: // value for 'employeeId'
 *      employerUuid: // value for 'employerUuid'
 *   },
 * });
 */
export function useEligibilitySummaryQuery(baseOptions: Apollo.QueryHookOptions<EligibilitySummaryQuery, EligibilitySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibilitySummaryQuery, EligibilitySummaryQueryVariables>(EligibilitySummaryDocument, options);
      }
export function useEligibilitySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibilitySummaryQuery, EligibilitySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibilitySummaryQuery, EligibilitySummaryQueryVariables>(EligibilitySummaryDocument, options);
        }
export type EligibilitySummaryQueryHookResult = ReturnType<typeof useEligibilitySummaryQuery>;
export type EligibilitySummaryLazyQueryHookResult = ReturnType<typeof useEligibilitySummaryLazyQuery>;
export type EligibilitySummaryQueryResult = Apollo.QueryResult<EligibilitySummaryQuery, EligibilitySummaryQueryVariables>;
export const GetPathwayDocument = gql`
    query getPathway($pathwayId: ID!, $employerId: ID!) {
  pathway(pathwayId: $pathwayId, employerId: $employerId) {
    content {
      heroImage
      title
    }
  }
}
    `;

/**
 * __useGetPathwayQuery__
 *
 * To run a query within a React component, call `useGetPathwayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPathwayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPathwayQuery({
 *   variables: {
 *      pathwayId: // value for 'pathwayId'
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useGetPathwayQuery(baseOptions: Apollo.QueryHookOptions<GetPathwayQuery, GetPathwayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPathwayQuery, GetPathwayQueryVariables>(GetPathwayDocument, options);
      }
export function useGetPathwayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPathwayQuery, GetPathwayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPathwayQuery, GetPathwayQueryVariables>(GetPathwayDocument, options);
        }
export type GetPathwayQueryHookResult = ReturnType<typeof useGetPathwayQuery>;
export type GetPathwayLazyQueryHookResult = ReturnType<typeof useGetPathwayLazyQuery>;
export type GetPathwayQueryResult = Apollo.QueryResult<GetPathwayQuery, GetPathwayQueryVariables>;
export const PricesByProgramDocument = gql`
    query PricesByProgram($academicPartnerUuid: ID!, $programUuid: ID!, $filters: [PriceFilter!]) {
  pricesByProgram(academicPartnerUuid: $academicPartnerUuid, programUuid: $programUuid, filters: $filters) {
    billingUnit
    costPerUnit
    priceType {
      name
    }
  }
}
    `;

/**
 * __usePricesByProgramQuery__
 *
 * To run a query within a React component, call `usePricesByProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricesByProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricesByProgramQuery({
 *   variables: {
 *      academicPartnerUuid: // value for 'academicPartnerUuid'
 *      programUuid: // value for 'programUuid'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePricesByProgramQuery(baseOptions: Apollo.QueryHookOptions<PricesByProgramQuery, PricesByProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricesByProgramQuery, PricesByProgramQueryVariables>(PricesByProgramDocument, options);
      }
export function usePricesByProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricesByProgramQuery, PricesByProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricesByProgramQuery, PricesByProgramQueryVariables>(PricesByProgramDocument, options);
        }
export type PricesByProgramQueryHookResult = ReturnType<typeof usePricesByProgramQuery>;
export type PricesByProgramLazyQueryHookResult = ReturnType<typeof usePricesByProgramLazyQuery>;
export type PricesByProgramQueryResult = Apollo.QueryResult<PricesByProgramQuery, PricesByProgramQueryVariables>;